import React from 'react';

const HorizontalLine = ({ color, thickness = '1' }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: `${thickness}px`,
        }}
    />
);

export default HorizontalLine;
